// 重构后的模块化入口文件
const { AwsMultipartUploader, taskManager } = require('./multipart-uploader');

/**
 * 多片上传入口函数
 */
function multipartUploadAws(file, options) {
    const uploader = new AwsMultipartUploader(file, options);
    uploader.startUpload();
    return uploader.taskId;
}

/**
 * 取消多片上传
 */
function cancelUpload(taskId) {
    return taskManager.cancelTask(taskId);
}

/**
 * 获取多片上传任务列表
 */
function getUploadTasks() {
    return taskManager.getAllTasks();
}

// 导出函数
multipartUploadAws.cancelUpload = cancelUpload;
multipartUploadAws.getUploadTasks = getUploadTasks;

module.exports = multipartUploadAws;
